// extracted by mini-css-extract-plugin
module.exports = {"Root":"Label_Root__KT5zO","IsTransperant":"Label_IsTransperant__l8Ewe","IsSplash":"Label_IsSplash__Yrhu2","IsDark":"Label_IsDark__GqQZb"};